import * as React from 'react';
import clsx from 'clsx';
import type { EchoProfileResponse } from '@/types/echo_creation';
import type { EchoKey } from '@/utils/constants';
import echoCreatedImage from '@/assets/images/webp/echo_created.webp';

// Dynamic Import to resolve Vite build warning and optimize code splitting
const ChatView = React.lazy(() =>
  import('@/features/chat/components/ChatView').then((module) => ({ default: module.ChatView }))
);

interface TestChatCardProps {
  echo: EchoProfileResponse;
}

export const TestChatCard: React.FC<TestChatCardProps> = ({ echo }) => {
  // If no echo yet (e.g., only drafts), don't render the test chat
  if (!echo) return null;

  const echoForChat = {
    id: echo.id,
    name: echo.name || 'My Echo',
    category: echo.category || 'Personal',
    domain: echo.domain || 'General',
    imageUrl: echo.profile_image_url || echoCreatedImage,
    videoAvatarUrl: echo.video_avatar_url ?? null,
    videoMessagesEnabled: echo.video_messages_enabled ?? false,
    idleVideoUrl: echo.idle_video_url ?? null,
  };

  return (
    <div
      className={clsx(
        // Mobile: Rounded 20, Fixed height 1200px (Doubled from 600px) using numeric token
        'flex flex-col',
        'overflow-hidden',
        'bg-white',
        'h-1000 rounded-20 border border-dark-100',
        // Desktop: Fill available height from grid (matches Left Column)
        'lg:h-full'
      )}
    >
      <React.Suspense
        fallback={
          <div className='flex size-full items-center justify-center bg-gray-50'>
            <div className='size-8 animate-spin rounded-full border-4 border-brand-300 border-t-brand-800' />
          </div>
        }
      >
        <ChatView
          echo={echoForChat}
          echoKey={echo.id as EchoKey}
          headerContent={undefined}
          compact
        />
      </React.Suspense>
    </div>
  );
};
